import { render, staticRenderFns } from "./BadgeActions.vue?vue&type=template&id=52b9e26d"
import script from "./BadgeActions.vue?vue&type=script&lang=js"
export * from "./BadgeActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports